import React from 'react';

import { useIsLoggedInQuery } from '../../redux/apis/authApi';

import { ROLES } from '../../utils/constant/global';
import CopyButton from './CopyButton';

const { ADMIN, HR } = ROLES;

function PersonalInformations({ information, title, icon, onClickEdit }) {
  const { data: authData } = useIsLoggedInQuery();

  return (
    <div className="card h-100 ep-info-card">
      <div className="card-header py-3 d-flex justify-content-between align-items-center">
        <div className="ep-info-card__title">
          {icon ? (
            <span className="ep-info-card__title-icon" aria-hidden>
              <i className={`bi ${icon}`} />
            </span>
          ) : null}
          <h6 className="mb-0 fw-bold">{title}</h6>
        </div>
        {[ADMIN, HR].includes(authData?.data?.hrxRole?.roleName) && (
          <button type="button" className="btn p-0" onClick={onClickEdit}>
            <i className="icofont-edit text-primary fs-6"></i>
          </button>
        )}
      </div>
      <div className="card-body">
        <div className="ep-fields">
          {(information || []).map((d, i) => (
            <div
              key={`${d.title}-${i}`}
              className={`ep-field${d.wide ? ' ep-field--wide' : ''}${d.truncate ? ' ep-field--truncate' : ''}`}
            >
              <span className="ep-field__icon" aria-hidden>
                <i className={`bi ${d.icon || 'bi-dot'}`} />
              </span>
              <div className="ep-field__body">
                <span className="ep-field__label">{d.title}</span>
                <span
                  className="ep-field__value"
                  title={typeof d.value === 'string' ? d.value : undefined}
                >
                  {d.value}
                </span>
              </div>
              {d.copyable && typeof d.value === 'string' && d.value !== '-' ? (
                <CopyButton text={d.value} label={`Copy ${String(d.title).toLowerCase()}`} />
              ) : null}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PersonalInformations;
